export var EasePattern;
(function (EasePattern) {
    EasePattern["EaseInQuad"] = "easeInQuad";
    EasePattern["EaseOutQuad"] = "easeOutQuad";
    EasePattern["EaseInOutQuad"] = "easeInOutQuad";
    EasePattern["EaseInCubic"] = "easeInCubic";
    EasePattern["EaseOutCubic"] = "easeOutCubic";
    EasePattern["EaseInOutCubic"] = "easeInOutCubic";
    EasePattern["EaseInQuart"] = "easeInQuart";
    EasePattern["EaseOutQuart"] = "easeOutQuart";
    EasePattern["EaseInOutQuart"] = "easeInOutQuart";
    EasePattern["EaseInQuint"] = "easeInQuint";
    EasePattern["EaseOutQuint"] = "easeOutQuint";
    EasePattern["EaseInOutQuint"] = "easeInOutQuint";
    EasePattern["NoEase"] = "";
})(EasePattern || (EasePattern = {}));
